module.exports = __webpack_public_path__ + "assets/aktivgrotesk-corp-regular.082ad4bb3b2bca1897b4f459fc0490da.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/aktivgrotesk-corp-regular.woff
// module id = 1137
// module chunks = 0